import { http } from '../utils/axios';
import { TGetPharmacyUpdate } from '../types';

class PrescriptionFulfillmentService {
  private static instance: PrescriptionFulfillmentService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): PrescriptionFulfillmentService {
    if (!PrescriptionFulfillmentService.instance) {
      PrescriptionFulfillmentService.instance =
        new PrescriptionFulfillmentService();
    }

    return PrescriptionFulfillmentService.instance;
  }

  getPharmacyUpdate = async (id: string) => {
    const { data } = await http<TGetPharmacyUpdate>({
      url: `/prescriptionFulfillment/${id}/actions/getPharmacyUpdate`,
      method: 'GET'
    });

    return data;
  };
}

const instance = PrescriptionFulfillmentService.getInstance();

export default instance;
